import Hero from './components/Hero';
import Mission from './components/Mission';
import ProgramsPreview from './components/ProgramsPreview';
import Impact from './components/Impact';
import GetInvolved from './components/GetInvolved';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Mission />
      <ProgramsPreview />
      <Impact />
      <GetInvolved />
    </div>
  );
}